import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { WeatherState } from './types';

export default function initialState(): WeatherState {
  return {
    ...initialStateSubscribable(),
  };
}
